export default __webpack_public_path__ + "static/media/heads-09.61243d7d.svg";